import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";

export const getRelationsCustomers = (async (pageNum,  pageSize  ,searchString ,orderBy,filterlist) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.CustomerRelationType.browse,
    method: 'get',
    params:{
        PageNumber: pageNum,
        PageSize: pageSize,
        OrderByString:orderBy,
        SearchString : searchString ,
        FilterString:filterlist,
        }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)

export const getRelationsCustomerById = (async (id) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url:ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.CustomerRelationType.load,
    method: 'get',
    params:{
        id
    }

})
    .then((response) => (response.data))

)

export const postRelationsCustomer = (data,method) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.CustomerRelationType.browse,
    method: method,
    data:data,
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})


